import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * Debug component to track navigation events and help identify routing issues
 */
export const DebugNavigationTracker: React.FC = () => {
  const location = useLocation();

  useEffect(() => {
    console.log('[NavigationTracker] ======= NAVIGATION EVENT =======');
    console.log('[NavigationTracker] New pathname:', location.pathname);
    console.log('[NavigationTracker] Search params:', location.search);
    console.log('[NavigationTracker] Hash:', location.hash);
    console.log('[NavigationTracker] State:', location.state);
    console.log('[NavigationTracker] Full URL:', window.location.href);
    console.log('[NavigationTracker] ===================================');
  }, [location]);

  return null; // This component only provides debugging, no UI
};